import {Component, OnInit} from '@angular/core';
import {ToolService} from '../../services/tool.service';
import {Tool} from '../../model/tool';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {AdminPageModelComponent} from "../../components/admin/admin-page-model/admin-page-model.component";
import {ToolBlockComponent} from "../../components/common/tool-block/tool-block.component";
import {ToolTypePipe} from "../../components/common/ToolTypePipe";
import {FormGroup} from "@angular/forms";

import {SortPipe} from "../../components/common/SortPipe";
import {DynamicModalFormComponent} from "../../components/common/dynamic-modal-form/dynamic-modal-form.component";
import {ToolFormGeneratorService} from "../../formulaires/admin/tool-form-generator.service";
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-tools',
    templateUrl: './tools.component.html',
    imports: [
    AdminPageModelComponent,
    FaIconComponent,
    ToolBlockComponent,
    ToolTypePipe,
    SortPipe,
    DynamicModalFormComponent
],
    styleUrls: ['./tools.component.css']
})
export class ToolsComponent implements OnInit {
  tools: Tool[] = [];
  toEdit: Tool;
  toDelete: Tool;

  editActions = [
    {
      condition: () => !!this.toEdit.id,
      label: 'Enregistrer',
      class: 'btn-primary',
      icon: 'save',
    }, {
      condition: () => !this.toEdit.id,
      label: 'Ajouter',
      class: 'btn-primary',
      icon: 'plus-circle',
    }
  ];

  constructor(private toolService: ToolService,
              public toolFormGeneratorService: ToolFormGeneratorService) {
  }

  ngOnInit(): void {
    this.toolService.getObjects().subscribe(data => {
      this.tools.length = 0;
      this.tools = this.tools.concat(data);
    });
  }

  createTool(): void {
    this.toEdit = new Tool();
  }

  editTool(tool: Tool): void {
    this.toEdit = Object.assign({}, tool);
  }

  askToDelete(tool: Tool): void {
    this.toDelete = Object.assign({}, tool);
  }

  save($event: any): void {
    this.toolService.createObject({...this.toEdit, ...$event});
  }

  deleteTool(): void {
    this.toolService.deleteObject(this.toDelete);
    this.toDelete = undefined;
  }
}
